import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "context/AuthContext";
import Icon from "components/AppIcon";
import LoginForm from "pages/login-screen/components/LoginForm";
import { getUserDashboardRoute } from "utils/roleUtils";

const RecruiterLogin = () => {
  const navigate = useNavigate();
  const { user, signOut } = useAuth();
  const [hasRedirected, setHasRedirected] = useState(false);

  useEffect(() => {
    if (user?.id && !hasRedirected) {
      // Strict Role Check for Recruiter Page
      const rawRole = user.role_name || user.role;
      let role = 'guest';

      if (typeof rawRole === 'string') {
          role = rawRole.toLowerCase();
      } else if (typeof rawRole === 'number') {
          const map = { 0: 'admin', 1: 'clab', 2: 'recruiter', 3: 'employer' };
          role = map[rawRole] || 'guest';
      }

      if (role === 'recruiter') {
          setHasRedirected(true);
          const dashboardRoute = getUserDashboardRoute(user.role);
          navigate(dashboardRoute, { replace: true });
      } else {
          // User is logged in but NOT a recruiter. Force logout.
          console.warn(`Blocked unwanted login on Recruiter Page: ${role}`);
          signOut();
      }
    }
  }, [user, hasRedirected, navigate, signOut]);

  return (
    <div className="min-h-screen w-full flex flex-col relative bg-[#F47B20] md:bg-[url('/assets/recruiter_login_bg.png')] md:bg-[length:100%_100%] md:bg-center md:bg-no-repeat">
      {/* Header */}
      <header className="relative z-20 w-full px-8 py-4 flex justify-center items-center bg-transparent">
        <nav className="flex items-center gap-8">
          <a
            href="#faq"
            className="text-white/90 hover:text-white text-sm font-medium transition-colors"
          >
            FAQ
          </a>
          <div className="relative group">
            <button className="flex items-center gap-1 text-white/90 hover:text-white text-sm font-medium transition-colors">
              User Manual
              <Icon name="ChevronDown" size={14} />
            </button>
          </div>
          <div className="relative group">
            <button className="flex items-center gap-1 text-white/90 hover:text-white text-sm font-medium transition-colors">
              Video
              <Icon name="ChevronDown" size={14} />
            </button>
          </div>
        </nav>
      </header>

      {/* Main Content - Centered on Mobile, Aligned Right on Desktop */}
      <main className="flex-1 flex items-center justify-center md:justify-end px-4 md:px-16 lg:px-24 relative z-10 pb-4">
        <div className="w-full max-w-md">
          {/* Logo Section */}
          <div className="text-center mb-6">
            <img
              src="/assets/logo_clab_white.png"
              alt="CLAB Logo"
              className="h-20 mx-auto mb-2 object-contain"
            />
            <img
              src="/assets/logo_ebiodata.png"
              alt="eBiodata Logo"
              className="h-12 mx-auto mb-2 object-contain drop-shadow-md"
            />
          </div>

          {/* Login Container - Transparent */}
          <div className="p-4">
            <h2 className="text-4xl font-bold text-white text-center mb-6 drop-shadow-md">Recruiter Login</h2>
            <LoginForm selectedLanguage="en" mode="recruiter" theme="recruiter" />

            <div className="mt-4 text-center">
              <Link
                to="/forgot-password"
                className="text-white/80 hover:text-white text-sm transition-colors"
              >
                Forgot Password ?
              </Link>
            </div>

            <div className="mt-4 text-center">
              <Link
                to="/login-screen"
                className="text-white hover:text-orange-200 underline text-sm font-bold"
              >
                Not Recruiter? Go to Main Login
              </Link>
            </div>
          </div>

          {/* Footer Info - Specific text provided - Hidden on Mobile */}
          <div className="mt-8 text-right text-xs text-white/90 font-medium leading-relaxed hidden md:block">
             <div className="flex justify-end items-center gap-4 mb-2">
                <span className="flex items-center gap-1"><Icon name="Phone" size={12} /> 03 2095 9599</span>
                <span className="flex items-center gap-1"><Icon name="MessageCircle" size={12} /> 012 694 9599</span>
                <span className="flex items-center gap-1"><Icon name="Mail" size={12} /> vdrclab@clab.com.my</span>
             </div>
             <p className="text-center w-full">Level 2, Annexe, Menara Milenium, No. 8, Jalan Damanlela Bukit Damansara,</p>
             <p className="text-center w-full">Damansara Town Centre, 50490 Kuala Lumpur.</p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default RecruiterLogin;
